import type { QuoteRequestStatus } from '@repo/api-contracts';
import type { StatusTone } from '@/shared/ui';

/**
 * 견적 상태 배지 톤 — 견적 목록(widgets/quote-list)과 같은 기준으로, 운영자가 지금 무엇을 해야 하는지로 나눈다.
 * attention 새 요청(검토 대기) / warning 고객이 수정을 요청한 건 / neutral 발행 뒤 고객 답을 기다리는 건 /
 * positive 주문으로 이어진 건 / danger 더 진행되지 않는 건(거절·반려·취소·만료).
 */
export const QUOTE_STATUS_TONES: Readonly<Record<QuoteRequestStatus, StatusTone>> = {
  REQUESTED: 'attention',
  REVISION_REQUESTED: 'warning',
  ISSUED: 'neutral',
  ORDERED: 'positive',
  DECLINED: 'danger',
  REJECTED: 'danger',
  CANCELED: 'danger',
  EXPIRED: 'danger',
};
